<template>
  <section ref="main" class="app-home">
    <LazyModuleHomeScreen1
      v-if="moduleHomeOneData"
      v-bind="moduleHomeOneData"
      :buttonGroup="
        moduleHomeOneData.entrance_list && moduleHomeOneData.entrance_list.length > 0
          ? moduleHomeOneData.entrance_list
              .filter((item: any) => item.status)
              .slice(0, 2)
              .map((item: any) => formatEntranceInfo(item.need_entrance, item.entrance_name, item.entrance_link))
          : []
      "
    />
    <div class="app-home-main">
      <IconsModuleDecorLine
        class="absolute -top-6 left-0 h-6 w-full text-[#FFAF00] max-lg:portrait:hidden max-lg:landscape:-top-4"
      />
      <IconsModuleDecorLineMob
        class="absolute -top-2.5 left-0 h-2.5 w-full text-[#FFAF00] max-lg:portrait:block hidden"
      />
      <LazyModuleHomeScreen2
        v-if="moduleHomeTwoData"
        :title="moduleHomeTwoData.title"
        :subtitle="moduleHomeTwoData.subtitle"
        :list="moduleHomeTwoData.news_banners"
      />
      <LazyModuleHomeScreen3
        v-if="moduleHomeThreeData"
        :name="moduleHomeThreeData.name"
        :title="moduleHomeThreeData.title"
        :subtitle="moduleHomeThreeData.subtitle"
        :images="moduleHomeThreeData.maps"
      />
      <LazyModuleHomeScreen4
        v-if="moduleHomeFourData && moduleHomeFourData.platforms.filter((item: any) => item.status).length >= 1"
        :title="moduleHomeFourData.title"
        :subtitle="moduleHomeFourData.subtitle"
        :cards="moduleHomeFourData.platforms"
      />
    </div>
  </section>
</template>
<script lang="ts" setup>
import { formatEntranceInfo } from '~/utils'
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['index-page-cache-tag'])
})
const { fetchPageData, filterModule } = usePageStore()
await fetchPageData('/')
const moduleHomeOneData = filterModule('ModuleHomePageScreen1')
const moduleHomeTwoData = filterModule('ModuleHomePageScreen2')
const moduleHomeThreeData = filterModule('ModuleHomePageScreen3')
const moduleHomeFourData = filterModule('ModuleHomePageScreen4')
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1024px) {
  .app-home {
    background-image: url('@/assets/images/home-bg.jpg');
    background-size: cover;
  }
}
.app-home-main {
  @apply relative z-[1] lg:pt-16 lg:pb-17.5 max-lg:pt-5.5 max-lg:pb-2.5;
}
</style>
